"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var WizardInputOptionsType;
(function (WizardInputOptionsType) {
    WizardInputOptionsType["entityType"] = "entityType";
    WizardInputOptionsType["commentaryType"] = "commentaryType";
    WizardInputOptionsType["disclaimerType"] = "disclaimerType";
    WizardInputOptionsType["property"] = "property";
    WizardInputOptionsType["statisticCode"] = "statisticCode";
    WizardInputOptionsType["allocationCode"] = "allocationCode";
    WizardInputOptionsType["timeseriesCode"] = "timeseriesCode";
    WizardInputOptionsType["statisticProperty"] = "statisticProperty";
    WizardInputOptionsType["allocationProperty"] = "allocationProperty";
    WizardInputOptionsType["timeseriesProperty"] = "timeseriesProperty";
})(WizardInputOptionsType = exports.WizardInputOptionsType || (exports.WizardInputOptionsType = {}));
//# sourceMappingURL=WizardInputOptionsType.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@kurtosys/ksys-app-template/dist/models/studio/wizard/WizardInputOptionsType.js
// module id = 1000
// module chunks = 1